<template>
    <div class="main-con">
        <el-form ref="form" :model="form" :rules="companyRules" label-position="left" label-width="140px" class="reg-form" > 
            <h3 class="title">会员注册</h3> 
            <el-row :gutter="60"> 
                <el-col :span="12"> 
                    <el-form-item label="单位全称" prop="companyCn"> 
                        <el-input v-model.trim="form.companyCn"   placeholder="请输入" /> 
                    </el-form-item> 
                </el-col> 
                <el-col :span="12"> 
                    <el-form-item label="单位类型" prop="compType"> 
                        <el-select v-model="form.compType" placeholder="请选择" style="width: 100%"> 
                            <el-option  label="金融机构" value="financialInstitution"></el-option>
                            <el-option  label="类金融机构" value="likeFinancialInstitution"></el-option>
                            <el-option  label="普通机构" value="generalorganization"></el-option>
                        </el-select> 
                    </el-form-item> 
                </el-col> 
                <el-col :span="12"> 
                    <el-form-item label="统一社会信用代码" prop="job"> 
                        <el-input v-model.trim="form.job"  placeholder="请输入" /> 
                    </el-form-item> 
                </el-col> 
                <el-col :span="12"> 
                    <el-form-item label="法定代表人姓名" prop="legalPerson"> 
                        <el-input v-model.trim="form.legalPerson" placeholder="请输入" /> 
                    </el-form-item> 
                </el-col> 
                <el-col :span="12"> 
                    <el-form-item label="单位注册地" prop="areaCode">
                        <el-cascader
                            style="width: 100%"
                            v-model="form.areaCode"
                            :options="areaOptions">
                        </el-cascader>
                    </el-form-item> 
                </el-col> 
                <el-col :span="12"> 
                    <el-form-item label="单位地址详址" prop="compAddr"> 
                        <el-input v-model.trim="form.compAddr" placeholder="请输入" /> 
                    </el-form-item> 
                </el-col> 
                <el-col :span="12"> 
                    <el-form-item label="联系人" prop="agencyPerson"> 
                        <el-input v-model.trim="form.agencyPerson" placeholder="请输入" /> 
                    </el-form-item> 
                </el-col> 
                <el-col :span="12"> 
                    <el-form-item label="联系人手机号" prop="mobile"> 
                        <el-input v-model.trim="form.mobile" :maxlength="11" placeholder="请输入" /> 
                    </el-form-item> 
                </el-col> 
                <el-col :span="12"> 
                    <el-form-item label="联系人邮箱" prop="orgEmail"> 
                        <el-input v-model.trim="form.orgEmail" placeholder="请输入" /> 
                    </el-form-item> 
                </el-col> 
                <el-col :span="12"> 
                    <el-form-item label="入会申请书" prop="fileAttach2"> 
                        <el-upload :on-success="(response,file) => handlePictureSuccess('fileAttach2',response,file)" :before-upload="handleBeforeUpload" :on-error="handleUploadError" :limit="1" :headers="upload.headers" :action="upload.url" :on-remove="handleRemove"> 
                            <i class="el-icon-plus"></i> 
                        </el-upload> 
                        <a class="link" style="margin-left: -100px;" :href="`./file/入会申请书-${subjectText}.doc`">入会申请书模板下载</a> 
                    </el-form-item> 
                </el-col> 
                <el-col :span="12"> 
                    <el-form-item label="营业执照" prop="licenseFile"> 
                        <el-upload :on-success="(response,file) => handlePictureSuccess('licenseFile',response,file)" :before-upload="handleBeforeUpload" :on-error="handleUploadError" :limit="1" :headers="upload.headers" :action="upload.url" :on-remove="handleRemove"> 
                            <i class="el-icon-plus"></i> 
                        </el-upload> 
                    </el-form-item> 
                </el-col> 
                
                <el-col :span="24" style="padding: 20px 30px;"> 
                    <el-checkbox v-model="checked"><a :href="`./file/《用户服务协议》-${subjectText}.pdf`" target="_blank">《用户服务协议》</a>、<a :href="`./file/存证服务授权书-${subjectText}.pdf`" target="_blank">《存证服务授权书》</a></el-checkbox>
                </el-col>
            </el-row> 
            <el-row class="center"> 
                <el-button type="primary" class="reg-but" @click="handleLogin">
                    立即注册
                </el-button> 
            </el-row> 
        </el-form> 

    </div>
</template>
<script>
import area from '@/utils/area';
import baseUrl from '@/api/baseUrl.js' 
import { encrypt } from '@/utils/jsencrypt'

export default {
    data () {
        return {                
            // 表单校验
            companyRules:{
                compType:[
                    { required: true, message: "企业类型不能为空", trigger: "blur" }
                ],
                areaCode:[
                      { required: true, message: "不能为空", trigger: "blur" }
                  ],
                companyCn: [
                        { required: true, message: "会员全称不能为空", trigger: "blur" }
                    ],
                job: [
                        { required: true, message: "统一社会信用代码不能为空", trigger: "blur" }
                    ],
                legalPerson: [
                        { required: true, message: "法人代表姓名不能为空", trigger: "blur" }
                    ],
                compAddr: [
                        { required: true, message: "机构联系地址不能为空", trigger: "blur" }
                    ], 
                orgEmail:[
                    {
                    required: true,
                    pattern:  /^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/,
                    message: "请输入正确的邮箱",
                    trigger: "blur"
                    },
                ],
                agencyPerson: [
                        { required: true, message: "联系人不能为空", trigger: "blur" }
                    ],
                mobile: [
                    { required: true, message: "联系人手机号不能为空", trigger: "blur" 	},
                    {
                        pattern: /^1[0-9][0-9]\d{8}$/,
                        message: "请输入正确的手机号码",
                        trigger: "blur"
                    },   
                    ],
                licenseFile: [
                    { required: true, message: "营业执照不能为空", trigger: "change" }
                ],
                fileAttach2: [
                    { required: true, message: "入会申请书不能为空", trigger: "blur" }
                ],
            },            
            areaOptions:area,
            codemsg:'获取验证码',
            form: {
                companyCn:'',
                compType:'',
                job: '',
                legalPerson: '',
                attrValues:[],
                areaCode: [],
                compAddr:'',
                agencyPerson:'',
                mobile: '',
                orgEmail: '',
                licenseFile:'',
                fileAttach2:'',
                subject: this.$route.query.subject
            },
            //10:草稿 1审核不通过 2待审核 3正常 4冻结 5注销 6锁定
            status: '',
            loading: false,

            // 用户导入参数
            upload: {
                // 是否显示弹出层（用户导入）
                open: false,
                // 弹出层标题（用户导入）
                title: "",
                // 是否禁用上传
                isUploading: false,
                // 是否更新已经存在的用户数据
                updateSupport: 0,
                // 设置上传的请求头部
                // headers: { Authorization: "Bearer " + this.getToken() },
                // 上传的地址
                url: baseUrl.newucUrl + "/usercenter/user/uplodFile"
            },
            checked: false,
            subjectText: ''
        };
    },
    mounted() {
        console.info(this.form.subject)
        console.info(this.$route.query.backurl)
        console.log('新版本')
        if(this.form.subject == 'qdyy'){
             this.subjectText = '青岛云毅'
        }else{
            this.subjectText = '中达链'
        }
    },
    methods: { 
        handleLogin() { 	     	 
            this.$refs.form.validate(valid => {
                if (valid) {
                    if(this.status == '3'){
                        this.$message.error('该企业已注册')
                        return
                    }
                    if(this.checked){                       
                        this.form.attrValues.push({attrKey:'orgEmail',attrValue:this.form.orgEmail })
                        this.form.attrValues.push({attrKey:'compType',attrValue:this.form.compType })
                        if(this.form.areaCode){
                            this.form.compProvinceCode = this.form.areaCode[0]
                            this.form.compCityCode = this.form.areaCode[1]
                            this.form.compDistrictCode = this.form.areaCode[2]
                        }
                        
                        const loading = this.$loading({
                        lock: true,
                        text: '请稍后',
                        spinner: 'el-icon-loading',
                        background: 'rgba(0, 0, 0, 0.7)'
                        });

                        this.loading = true;
                        var formData = new FormData();
                        for(let i in this.form){
                            if(i == 'password'){
                                formData.append('password', encrypt(this.form.password))
                            }else if(i != 'attrValues'){
                                formData.append(i, this.form[i])
                            }

                        }

                        this.form.attrValues.map((item,i) =>{
                            formData.append(`attrValuesList[${i}].attrKey`, this.form.attrValues[i].attrKey)
                            formData.append(`attrValuesList[${i}].attrValue`, this.form.attrValues[i].attrValue)
                        })
                        var that = this;
                        this.$api.api.registerOrgan(formData).then(res => {
                            if (res.code == 200) {
                                this.loading = false;
                                this.$message.success("注册成功！")

                                setTimeout(function(){
                                    if(that.$route.query.backurl){
                                        window.parent.location.href = that.$route.query.backurl
                                    }else {
                                        window.location.reload()
                                    }
                                },2000) 
                            }else{
                                setTimeout(function(){
                                    if(that.$route.query.backurl){
                                        window.parent.location.href = that.$route.query.backurl
                                    }else {
                                        window.location.reload()
                                    }
                                },2000)
                                this.loading = false;
                                this.$message.error(res.msg)
                            } 

                            loading.close();	            
                        });
                    }else{
                        this.$message.warning("请先同意《用户服务协议》《存证服务授权书》！")
                    }

                }
            });
		},
        // @change="changeJob"
        changeJob(){
            
            if(this.form.job && this.form.job.length > 0 && this.form.companyCn && this.form.companyCn.length > 0){            
                this.$api.api.getOrganInfor({jobCode:this.form.job,compName:this.form.companyCn}).then(res => { 
                    if (res.code == 200) {
                        console.log(res.data)
                            this.form.companyCn = res.data.companyCn
                            this.form.areaCode = [res.data.compProvinceCode,res.data.compCityCode,res.data.compDistrictCode]
                            this.form.compAddr = res.data.compAddr
                            this.form.agencyPerson = res.data.agencyPerson
                            this.form.mobile = res.data.mobile
                            this.status = res.data.status
                            res.data.attrValuesList.map((item,i)=>{
                                if(item.attrKey == 'orgEmail' && item.attrValue != 'undefined'){
                                    this.form.orgEmail = item.attrValue
                                    this.form.attrValues.push({'attrKey':item.attrKey,'attrValue':item.attrValue})
                                }
                                if(item.attrKey == 'compType' && item.attrValue != 'undefined'){
                                    this.form.compType = item.attrValue
                                    this.form.attrValues.push({'attrKey':item.attrKey,'attrValue':item.attrValue})
                                }
                                if(item.attrKey == 'licenseFile' && item.attrValue != 'undefined'){
                                    this.form.licenseFile = item.attrValue
                                    this.form.attrValues.push({'attrKey':item.attrKey,'attrValue':item.attrValue})
                                }
                                if(item.attrKey == 'fileAttach2' && item.attrValue != 'undefined'){
                                    this.form.fileAttach2 = item.attrValue
                                    this.form.attrValues.push({'attrKey':item.attrKey,'attrValue':item.attrValue})
                                }
                                    
                            })
                            this.form.legalPerson = res.data.legalPerson      
                    }
                    else{
                        console.log(res.msg)
                        //    this.form.compType=''
                        //    this.form.legalPerson= ''
                        //    this.form.attrValues=[]
                        //    this.form.areaCode= []
                        //    this.form.compAddr=''
                        //    this.form.agencyPerson=''
                        //    this.form.mobile= ''
                        //    this.form.orgEmail= ''
                        //    this.form.licenseFile=''
                        //    this.form.fileAttach2=''
                        //    this.status = ''
                    }
                })
            }
            
            
        },
        handleUploadError() {
            this.$message({
            type: "error",
            message: "上传失败",
            });
            this.loading.close();
        },
        handlePictureSuccess(key,file, fileList){
            this.$refs.form.clearValidate(key)
            this.form[key] = file.msg 
            this.form.attrValues.push({attrKey:key,attrValue:file.msg })
            this.loading.close();
        }, 
        handleRemove(file, fileList) {
            console.log(file, fileList);
        },
        handleBeforeUpload() {
            this.loading = this.$loading({
                lock: true,
                text: "上传中",
                background: "rgba(0, 0, 0, 0.7)",
            });
        }
    }
};
</script>

<style lang="less">
@import '../assets/css/commen';
@import './style.less';
.reg-form{
    margin: 0 auto;
    width: 1100px;
    .title {
        text-align: center;
        margin: 30px auto 40px;
    }
    .center {
        text-align: center;
    }
    .reg-but{
        margin: 60px auto 30px;
        width: 200px;
        height: 40px;
    }
}
</style>